export const LoggedOutEmptyStateImage = () => null;
